import React, { useState, useEffect } from 'react';
import { Badge, Modal, ModalBody,  CardFooter,  ButtonGroup,  Card,  CardBody,  CardHeader,  Col,  Row,  Button,  Input,  FormGroup, FormFeedback,  Label} from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';
import { AppSwitch } from '@coreui/react'

import { parseBool, getAction, postAction, putAction, deleteAction } from '../../../utils/ApiHandler';
import {customStyles, TextField, ClearButton} from '../../../utils/customStyle';  
import Loader from "react-spinners/MoonLoader";
import { css } from "@emotion/core";
const override = css`
  display: block;
  position: fixed;
  margin: 0 auto;
  z-index: 9999;
  left: 50%;
  top: 15%;
  border-color: red;
`;
const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

const EstadoLectura = () => {
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');

    const [getId,     setId] = useState('');
    const [getOrden,  setOrden] = useState(0);
    const [getNombre, setNombre] = useState('');
    const [getValorDefecto,  setValorDefecto] = useState(false)

    const [getOrdenError,  setOrdenError] = useState({valid: true, message: ''});
    const [getNombreError, setNombreError] = useState({valid: true, message: ''});
    
    const empresaId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).empresa_id : ''
    const [getGifLoader, setGifLoader] = useState(false);

    //const [getValorDefectoError, setValorDefectoError] = useState({valid: true, message: ''});
    
  // zona  de filtro
  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <TextField id="search" type="text" placeholder="Filter" value={filterText} onChange={onFilter} autoFocus={true}  />
      <ClearButton onClick={onClear}>X</ClearButton>
    </>
  );
  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };
    return <FilterComponent  onFilter={e => setFilterText(e.target.value.toUpperCase())} onFocus={e => setFilterText(e.target.onFocus)}  onClear={handleClear} filterText={filterText.toUpperCase()}   />;
  }, [filterText, resetPaginationToggle]);
 
  const filteredItems = data.filter(item => ((item.nombre.toUpperCase() && item.nombre.toUpperCase().includes(filterText)) || 
                                             (item.orden.toString() && item.orden.toString().includes(filterText)) ));
// hasta aca zona de filtro

  const toggle = () => {
    hideErrors()
      setModalTitle('Agregar Estado de Lectura')
      setId('')
      setOrden(0)
      setNombre('')
      setValorDefecto(false)
      setModal(!modal);
  }
  useEffect(() => {
      getEstadoLecturaList();
      document.getElementById("_agregar").focus();
  }, []);


  const showErrors = (errors) => {
    errors.forEach(err => {
      switch(err.param) {
        case 'orden':
          setOrdenError({valid:false, message: err.msg })
          break;
        case 'nombre':
          console.log(err)
          setNombreError({valid:false, message: err.msg })
          break;
        
        default:
          break;
      }
    })
  }  
  const hideErrors = () => {
    setOrdenError({valid:true, message: '' })
    setNombreError({valid:true, message: '' })
  }

  //Listar 
    const getEstadoLecturaList = async () => {
      try {
        setGifLoader(true)
        const res = await getAction('/api/estadolectura/' + empresaId)
        if (!res.ok) {
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            setData(resp.data)
            setGifLoader(false)
          })
        )
      }
      catch (err) {
        setGifLoader(false)
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener la lista de Estado de Lectura!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
    }

  //Crea 
    const createEstadoLectura = async (estadolectura) => {
      try {
        const res = await postAction('/api/estadolectura', estadolectura);
        if (!res.ok) {
          if(res.status === 422)
            res.json().then(err_resp => showErrors (err_resp.errors))
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            console.log(resp.data)
            setData(data => [...data, resp.data[0]])
            toggle();
            toast.success(<span><i className="fa fa-successs"></i> Datos guardados con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
          })
        )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al guardar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
    }

  //Actualiza 
    const updateEstadoLectura = async (estadolectura) => {
      try {
        const res = await putAction('/api/estadolectura/' + estadolectura.id, estadolectura)
        if (!res.ok) {
          if(res.status === 422)
            res.json().then(err_resp => showErrors (err_resp.errors))
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            let newArr = [...data]; // copying the old datas array      
            let index = data.findIndex((o) => { return o.id === estadolectura.id });
            newArr[index] = resp.data[0]
            setData(newArr);
            toggle();
            toast.success(<span><i className="fa fa-successs"></i> Datos actualizados con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
          })
        )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al guardar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
    }

  //Elimina Region
    const deleteEstadoLectura = async (estadoLecturaId) => {
      try {
        const res = await deleteAction('/api/estadolectura/' + estadoLecturaId)
        if (!res.ok) {
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            console.log(resp.data[0])
            setData(data.filter(item => item.id !== estadoLecturaId))
            toast.success(<span><i className="fa fa-successs"></i> Registro eliminado con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
          })
        )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al eliminar Estado de Lectura!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
    }

  //Acciones Region
    const editAction = (e, row) => {
      toggle()
      setModalTitle('Editar Estado de Lectura')
      setId(row.id)
      setOrden(row.orden)
      setNombre(row.nombre)
      setValorDefecto(parseBool(row.valor_defecto))
    }

    const saveChangesAction = () => {    
      var _filtro = data.filter(items => items.valor_defecto === true)
      if (_filtro.length > 0){
         if (_filtro[0].nombre !== getNombre && getValorDefecto === true) {
            toast.warning(<span><i className="fa fa-successs"></i>No puede haber otro registro por Defecto</span>, {position: toast.POSITION.TOP_RIGHT})
            return
         }
      }
      var editedData = {
          id:            getId,
          empresa_id:    empresaId,
          orden:         getOrden,
          nombre:        getNombre,
          valor_defecto: getValorDefecto
      }
      if(getId === ''){
        createEstadoLectura(editedData)
      }else{
        editedData.id = getId
        updateEstadoLectura(editedData)
      }
  }

    const deleteEstadoLecturaAction= (e, row) => {
      if (row.is_valido === true) {
          toast.warning(<span><i className="fa fa-minus-circle"></i> Este Estado no se puede borrar,  se agregó en alguna lectura.</span>, {position: toast.POSITION.TOP_RIGHT})
          return
      }
      confirmAlert({
        title: 'Eliminar Estado de Lectura',
        message: row.nombre + '?',
        buttons: [
          {
            label: 'Si',
            onClick: () => {
              deleteEstadoLectura(row.id)
            }
          },
          {
            label: 'No'
          }
        ]
      });
    }
   
//Customize
  const columns = [
    {
      name: 'Orden',
      selector: 'orden',
      sortable: true
    },
    {
      name: 'Nombre',
      selector: 'nombre',
      sortable: true
    },
    {
      name: 'Valor Defecto',
      cell: row => row.valor_defecto ? <h4><Badge color="success" style={{marginTop: "5px"}}> Si </Badge></h4> : <></>,
      sortable: true
    },
    {
      cell: row =>  <ButtonGroup>
                        <Button title="Editar" onClick={(e) => editAction(e, row)} style={{marginRight: "5px", borderRadius: "5px"}}><i className="icon-pencil fa-boton"></i></Button>
                        <Button title="Borrar" onClick={(e) => deleteEstadoLecturaAction(e, row)} style={{marginRight: "5px", borderRadius: "5px"}}><i className="icon-trash fa-boton"></i>
                    </Button></ButtonGroup>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];


  return (
      <div className="animated fadeIn">
        <ToastContainer />
        <Row>
          <Col xs="12" lg="10">
            <div className="sweet-loading">
              <Loader
                css={override}
                size={80}
                color={"#4A90E2"}
                loading={getGifLoader}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg="12">
            <Card>
              <CardHeader>
                <i className="fa fa-align-justify"></i> Mantenedor de Estado de Lectura
                <div className="card-header-actions">
                <Button id="_agregar" color="primary" onClick={toggle} className="btn-setting"><i className="fa fa-plus"></i> Agregar</Button>
                </div>
              </CardHeader>
              <CardBody>
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  noHeader
                  pagination
                  paginationComponentOptions={paginationOptions}
                  paginationRowsPerPageOptions={[10, 15, 20, 25]}
                  customStyles={customStyles}
                  highlightOnHover
                  defaultSortField="nombre"
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  persistTableHead
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={modal} toggle={toggle} className="modal-dialog modal-dialog-centered">
        <CardHeader className="cardHeader">
              <i className="icon-note"></i> {modalTitle}
          </CardHeader>
          <ModalBody>
              <FormGroup>
                  <Label for="sector_nombre">Nombre</Label>
                  <Input type="text" invalid={!getNombreError.valid} id="sector_nombre" value={getNombre} onChange={(e) => setNombre(e.target.value.toUpperCase())}></Input>
                  <FormFeedback>{getNombreError.message}</FormFeedback>
              </FormGroup>
              <Row>
                  <Col md="6">
                      <FormGroup>
                          <label htmlFor="numero">Orden</label>
                          <Input type="number"  invalid={!getOrdenError.valid} id="numero" value={getOrden}  onChange={(e) => setOrden(e.target.value) }/>
                          <FormFeedback>{getOrdenError.message}</FormFeedback>
                      </FormGroup>
                  </Col>
                  <Col md="6">
                      <FormGroup>
                          <Label for="convenio_banco">Valor Defecto</Label>
                          <Row>
                            <Col md="12">
                              <AppSwitch id="valor_defecto" className={'mx-1'} variant={'3d'} color={'primary'} checked={getValorDefecto} onChange={(e) => { setValorDefecto(e.target.checked)}}/>
                            </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          </ModalBody>
          <CardFooter>
                  <Button color="success" onClick={toggle} className="btn btn-setting" style={{float: "right", marginRight: "20px"}}><i className="icon-logout"></i> Volver</Button>
                  <Button color="primary" onClick={saveChangesAction} style={{float: "right", marginRight: "20px"}}>Guardar Cambios</Button>{' '}
              </CardFooter>
        </Modal>

      </div>
    );
}

export default EstadoLectura;